// REM marketing page (app/Views/marketing/home.php): journey/reference tabs and the demo request form.

document.querySelectorAll('[data-tabs]').forEach((group) => {
  const tabs = [...group.children];
  const panels = [...document.querySelectorAll(`[data-panel="${group.dataset.tabs}"]`)];
  tabs.forEach((tab, n) => tab.addEventListener('click', () => {
    tabs.forEach((t, i) => { t.classList.toggle('on', i === n); t.setAttribute('aria-pressed', String(i === n)); });
    panels.forEach((p, i) => p.classList.toggle('on', i === n));
  }));
});

const form = document.getElementById('demo-form');
if (form) {
  const status = form.querySelector('.status');
  const button = form.querySelector('button[type="submit"]');
  const show = (msg, error) => { status.textContent = msg; status.classList.toggle('err', error); };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    form.querySelectorAll('[required]').forEach((el) => el.classList.add('touched'));
    if (!form.checkValidity()) {
      show(form.dataset.msgInvalid, true);
      return;
    }
    button.disabled = true;
    show(form.dataset.msgSending, false);
    try {
      const key = form.dataset.recaptchaKey;
      if (key && window.grecaptcha?.enterprise) {
        await new Promise((resolve) => grecaptcha.enterprise.ready(resolve));
        form.elements.reCaptchaToken.value = await grecaptcha.enterprise.execute(key, { action: 'DEMO_REQUEST' });
      }
      const res = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
      });
      if (res.ok) {
        form.reset();
        form.querySelectorAll('.touched').forEach((el) => el.classList.remove('touched'));
        show(form.dataset.msgOk, false);
        return;
      }
      const messages = { 400: form.dataset.msgCaptcha, 422: form.dataset.msgInvalid, 429: form.dataset.msgLimited };
      show(messages[res.status] || form.dataset.msgError, true);
    } catch {
      show(form.dataset.msgError, true);
    } finally {
      button.disabled = false;
    }
  });
}
